<template>
    <div class="row" id="mmy-row" v-if="Object.keys(emeaCableData).length > 0">
        <div class="flex full-width">
            <div class="vehicle-input-title col xs-4 sm-4 md-6 lg-6">{{ `${MMYType} ${index + 1}` }}</div>
            <div class="row full-width">
                <v-button
                    class="full-width "
                    position="right"
                    mobile="6"
                    tablet="6"
                    desktop="6"
                    styling="tertiary"
                    :disabled="false"
                    textAlign="right"
                    @onClickEvent="removeRow">
                    <template v-slot:content>
                        <span>
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z" fill="#0D6EDE"/>
                            </svg>
                            <span class="underline">{{ webstoreContent.cartPage.remove }}</span>
                        </span>
                    </template>
                </v-button>
            </div>
        </div>
        <vSelect
            class="mmy-input"
            :placeholder="webstoreContent.cartPage.make"
            :options="makes"
            :value="row.make"
            :id="`make_${index+1}`"
            @input="setRowAttribute($event, 'make')">
        </vSelect>

        <vSelect
            class="mmy-input"
            :placeholder="webstoreContent.cartPage.vehicle_type"
            :options="vehicleTypes"
            label="displayName" 
            :reduce="displayName => displayName.code"
            :value="webstoreContent.cartPage[row.vehicleType]"
            :id="`vehicle_type_${index+1}`"
            @input="setRowAttribute($event, 'vehicleType')">
        </vSelect>

        <vSelect
            class="mmy-input"
            :placeholder="webstoreContent.cartPage.year"
            :options="years"
            :value="row.year"
            @input="setRowAttribute($event, 'year')"
            :id="`year_${index+1}`"
            >
        </vSelect>

        <vSelect class="mmy-input"
            v-if="FMSGateway.length"
            placeholder="FMS Gateway"
            :options="FMSGateway"
            :value="row.FMSGateway"
            @input="setRowAttribute($event, 'FMSGateway')"
            :id="`FMS_Gateway_${index+1}`"
            ></vSelect>

        <vSelect class="mmy-input"
            v-if="remoteTacho.length"
            placeholder="Remote Tacho Download"
            :options="remoteTacho"
            :value="row.remoteTacho"
            @input="setRowAttribute($event, 'remoteTacho')"
            :id="`remote_tacho_${index+1}`"
            ></vSelect>

        <input class="mmy-quantity" 
            type="number" 
            :placeholder="webstoreContent.cartPage.quantity" 
            min="0" 
            v-model="displayedQuantity"
            :id="`quantity_${index+1}`"
            />
    </div>
</template>

<script>
    import vSelect from "vue-select";
    import "vue-select/src/scss/vue-select.scss";
    import {mapGetters, mapMutations} from 'vuex';
    import vButton from '../utils/button';

    export default {

        components: {vSelect, vButton},

        props: ['makes', 'emeaCableData', 'row', 'index'],

        data() {
            return {

            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
                'displayVehicleCableSelectionOptions',
            ]),

            ...mapGetters('content', [
                'webstoreContent',
            ]),

            ...mapGetters('checkout', [
                'currencyIsoCode'
            ]),

            MMYType() {
                return this.displayVehicleCableSelectionOptions ? this.webstoreContent.selectProductsPage.vehicle : this.webstoreContent.selectProductsPage.asset_type;

            },

            vehicleTypes() {
                let vehicleTypeOptions = [];
                if (this.emeaCableData.hasOwnProperty(this.row.make)) {
                    for (let option of Object.keys(this.emeaCableData[this.row.make])) {
                        vehicleTypeOptions.push({displayName: this.webstoreContent.cartPage[option], code: option});
                    }
                }
                return vehicleTypeOptions;
            },
            years() {
                let emeaCableData = this.emeaCableData;
                let make = this.row.make;
                let vehicleType = this.row.vehicleType;
                let years = [];

                if (emeaCableData && make && vehicleType) {
                    for (let yearRange of Object.keys(emeaCableData[make][vehicleType])) {
                        years.push(...emeaCableData[make][vehicleType][yearRange].year);
                    }
                }
                return years;
            },
            remoteTacho() {
                let emeaCableData = this.emeaCableData;
                let make = this.row.make;
                let vehicleType = this.row.vehicleType;
                let year = this.row.year;

                if (make && vehicleType && year) {
                    if (this.showOptions('remote_tacho')) {
                        let yearKey = this.determineYearKey();
                        return emeaCableData[make][vehicleType][yearKey].remote_tacho;
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }

            },
            FMSGateway() {
                let emeaCableData = this.emeaCableData;
                let make = this.row.make;
                let vehicleType = this.row.vehicleType;
                let year = this.row.year;

                if (make && vehicleType && year) {
                    if (this.showOptions('FMS_gateway')) {
                        let yearKey = this.determineYearKey();
                        return emeaCableData[make][vehicleType][yearKey].FMS_gateway;
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            displayedQuantity: {
                get() {
                    return this.row.quantity === 0 ? '' : this.row.quantity;
                },
                set(newQuantity) {
                    newQuantity = Math.abs(parseInt(newQuantity));
                    this.setRowAttribute(newQuantity, 'quantity');
                }
            },
        },

        methods: {
            showOptions(attribute) {
                let yearKey = this.determineYearKey();
                return !this.emeaCableData[this.row.make][this.row.vehicleType][yearKey][attribute].includes('Not applicable');
            },
            determineYearKey() {
                for (let yearIndexKey of Object.keys(this.emeaCableData[this.row.make][this.row.vehicleType])) {
                    const indexes = yearIndexKey.split(",");
                    if ((parseInt(indexes[0]) <= this.row.year) && (this.row.year <= parseInt(indexes[1]))) {
                        return yearIndexKey;
                    }
                }
            },
            setRowAttribute(newValue, attribute) {
                let payload = {index: this.index, attribute: attribute, value: newValue};
                this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/setRowAttribute`, payload);
            },

            clearAttribute(payload) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearAttribute`, payload);
            },

            bulkClearAttribute(clearAttributeList) {
                for (let attribute of clearAttributeList) {
                    this.clearAttribute({index: this.index, attribute: attribute});
                }
            },

            removeRow() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/removeRow`, this.index);
            },
        },
        watch: {
            'row.make': function() {
                this.bulkClearAttribute(['vehicleType', 'year']);
                this.setRowAttribute('Not applicable', 'remoteTacho');
                this.setRowAttribute('Not applicable', 'FMSGateway');
            },
            'row.vehicleType': function() {
                this.bulkClearAttribute(['year']);
                this.setRowAttribute('Not applicable', 'remoteTacho');
                this.setRowAttribute('Not applicable', 'FMSGateway');
            },
            'row.year': function() {
                if (this.row.make && this.row.vehicleType) {
                    if (this.remoteTacho.length > 0) {
                        this.bulkClearAttribute(['remoteTacho']);
                    }
                    if (this.FMSGateway.length > 0) {
                        this.bulkClearAttribute(['FMSGateway']);
                    }
                } else {
                    this.setRowAttribute('Not applicable', 'remoteTacho');
                    this.setRowAttribute('Not applicable', 'FMSGateway');
                }
            },
        }


    }
</script>

<style lang="scss" scoped>

    .vehicle-input-title {
        font-size: 24px;
        margin: 24px 0px;
        padding: 0;
    }

    #remove-mmy-row-x-icon{
        max-width: 7.3%; /* Fix spacing on Safari */
        padding-top: 2%;
    }

    .flex {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
    }

    .flex-center {
        align-items: center;
        justify-content: center;
    }

    #mmy-row {
        padding-bottom: 20px;
        border-bottom: 1px solid #E4E7EB;
    }

    span {
        cursor: pointer;
    }

    ::v-deep {
        button {
            border: 1px solid #c1c9d1;
            border-radius: 5px;
            height: 48px;
            padding: 0 10px;
        }
        ::placeholder {
            color: #757575;
        }

        .mmy-input {
            width: 100%;
            margin: 0px;
            margin-bottom: 40px;
            padding-left: 0px;

            .vs__dropdown-toggle {
                border: 1px solid #c1c9d1;
                height: 48px;
            }

            .vs__selected-options {
                overflow-x: hidden;
            }

            .vs__clear {
                display: none;
            }

            .vs__selected {
                white-space: nowrap;
            }

            .vs__dropdown-menu {
                width: 100%;
                min-width: 0px;

                padding-left: 0px 50px 0px 0px;
            }
        }
    }

    .mmy-quantity {
        width: 100%;
        padding-left: 11px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #c1c9d1;
    }

    .vehicle-input {
        border: transparent;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-basis: 20%;
        position: relative;
    }

    .vehicle-input-dropdown, .quantity-input {
        margin-bottom: 0px;
    }

    .vehicle-input-dropdown {
        width: 100%;
        border: transparent;
    }

    #remove-mmy-row-button {
        display: none;
        color: white;
        height: 48px;
        background-color: #eb0045;
        border-radius: 4px;
        border: none;
        font-size: 20px;
        line-height: 20px;
        margin-top: 2%;
    }

    #remove-mmy-row-button:hover {
        cursor: pointer;
        background-color: #EB004C;
        border: #0d6ede;
    }

    @media only screen and (max-width: 735px) {
        .mmy-input {
            margin-top: 10px;
            padding-right: 0px;
        }

        .mmy-quantity {
            margin-top: 10px;
        }

        #remove-mmy-row-button {
            display: block;
            margin-top: 10px;
        }

        #remove-mmy-row-x-icon {
            display: none;
        }
    }

</style>
